import Tutorial from './Tutorial';
import common from '../../common';
import {translate} from '../../utils';
import WalkCommand from '../../commands/WalkCommand';
import TurnCommand from '../../commands/TurnCommand';

export default class TutorialLevel4 extends Tutorial {
	constructor(finger, panel, scene, commands) {
		super(finger, panel, scene, commands);
	}

	update() {
		super.update();
	}

	play() {
		super.play();

		if (this._destroyed) {
			return;
		}

		this.tweens.removeAll();
		this._commands.ui.add.interactive = false;
		this._scene.cameraButton.interactive = false;

		let lastTween = null;

		if (this.stage === 0) {
			this._finger.rotation = 0;
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._finger.position.set((((common.STAGE_WIDTH - P3.View.width) * 0.5) + 220) - this._commands.ui.x, (common.STAGE_HEIGHT * 0.5) - 100);
			common.focusOverlay.setFocus(20, 200, 255, 100);

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE4.TAP_TURN_COMMAND');
			this.signals.update.dispatch();

			const t1 = new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -15 * PIXI.DEG_TO_RAD
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 1) {
			this._finger.alpha = 1;
			this._finger.scale.set(1, 1);
			this._finger.rotation = 0;
			this._finger.position.set((((common.STAGE_WIDTH - P3.View.width) * 0.5) + 350) - this._commands.ui.x, (common.STAGE_HEIGHT * 0.5) - 100);
			common.focusOverlay.setFocus(20, 200, 380, 100);

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE4.TAP_DIRECTION');
			this.signals.update.dispatch();

			const t1 = new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -15 * PIXI.DEG_TO_RAD
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 2) {
			this._finger.rotation = 0;
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._finger.position.set((common.STAGE_WIDTH * 0.5) + 100 - this._commands.ui.x, common.STAGE_HEIGHT - 180);
			this._commands.ui.interactive = false;
			this._commands.ui.interactiveChildren = false;
			common.focusOverlay.focusSprite(this._scene.runButton, true);

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE4.TAP_RUN');
			this.signals.update.dispatch();

			const t1 = new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -15 * PIXI.DEG_TO_RAD
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			t1.onComplete(() => {
				return lastTween.start();
			});
		}

		if (lastTween) {
			lastTween.onComplete(() => {
				P3.utils.delayg(this.tweens, 0.5, () => {
					this.play();
				});
			});
		}
	}

	stop() {
		super.stop();
	}

	prepareCommands() {
		super.prepareCommands();

		for (let i = 0; i < 4; i++) {
			let command = null;

			if (i !== 2) {
				command = new WalkCommand();
			} else {
				command = new TurnCommand();
			}

			command.template = false;
			command.grabbable = false;
			command.placed = true;
			this._commands.commandContainer.addChild(command);
			command.x = 169;
			command.setText(command.defaultVariable);
			for (const comm of this._commands.commands) {
				comm.slotPosition.set(comm.position.x, comm.position.y);
			}

			this._commands.commands.splice(i + 1, 0, command);

			if (i === 2) {
				command.interactive = true;
				command.signals.pickup.detachAll();
				command.signals.touch.add(this._commands.onCommandTouch, this._commands);
				command.signals.onVariableTouch.add(this._commands.onVariableTouch, this._commands);
				command.variable = 'right';
				command.setText('right');
			}

			this._commands.resize();
		}
	}
}
